import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { consultingServices } from '../mock/data';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import './Consulting.css';

const Consulting = () => {
  return (
    <div className="consulting-page">
      {/* Hero */}
      <section className="consulting-hero-section">
        <div className="section-content">
          <h1 className="display-huge">Consulting Services</h1>
          <p className="body-large consulting-hero-subtitle">
            Systematic solutions that transform your business from reactive to strategic, 
            from chaotic to scalable.
          </p>
        </div>
      </section>

      {/* Services */}
      <section className="consulting-services-section">
        <div className="section-content">
          {consultingServices.map((service, idx) => (
            <div key={service.id} className={`consulting-service-block ${idx % 2 === 1 ? 'reverse' : ''}`}>
              <Card className="consulting-service-card">
                <div className="service-number">0{service.id}</div>
                <h2 className="display-medium">{service.title}</h2>
                <p className="body-large service-description">{service.description}</p>
                
                <div className="service-section">
                  <h3 className="heading-2">What You Get</h3>
                  <div className="outcomes-list">
                    {service.outcomes.map((outcome, oidx) => (
                      <div key={oidx} className="outcome-item-detailed">
                        <CheckCircle size={24} className="outcome-icon-detailed" />
                        <p className="body-medium">{outcome}</p>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="service-benefit">
                  <div className="benefit-label">The Result</div>
                  <p className="body-large">{service.benefits}</p>
                </div>
              </Card>
            </div>
          ))}
        </div>
      </section>

      {/* Process */}
      <section className="consulting-process-section">
        <div className="section-content">
          <h2 className="display-medium text-center">How We Work</h2>
          <p className="body-medium text-center section-subtitle">
            A proven process for sustainable transformation
          </p>
          <div className="process-timeline">
            <div className="process-step">
              <div className="process-step-number">01</div>
              <div className="process-step-content">
                <h3 className="heading-2">Discovery Call</h3>
                <p className="body-medium">We understand your business, challenges, and goals in depth</p>
              </div>
            </div>
            <div className="process-connector"></div>
            <div className="process-step">
              <div className="process-step-number">02</div>
              <div className="process-step-content">
                <h3 className="heading-2">Strategic Assessment</h3>
                <p className="body-medium">Deep dive analysis to identify gaps and opportunities</p>
              </div>
            </div>
            <div className="process-connector"></div>
            <div className="process-step">
              <div className="process-step-number">03</div>
              <div className="process-step-content">
                <h3 className="heading-2">Custom Solution Design</h3>
                <p className="body-medium">Build systems and frameworks tailored to your business</p>
              </div>
            </div>
            <div className="process-connector"></div>
            <div className="process-step">
              <div className="process-step-number">04</div>
              <div className="process-step-content">
                <h3 className="heading-2">Implementation & Support</h3>
                <p className="body-medium">Hands-on deployment with ongoing optimization</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Investment */}
      <section className="consulting-investment-section">
        <div className="section-content">
          <div className="investment-content">
            <h2 className="display-medium">Investment & Engagement</h2>
            <p className="body-large">
              We work with a limited number of clients to ensure exceptional results. 
              Our engagements typically range from 3-12 months depending on scope and complexity.
            </p>
            <div className="investment-details">
              <div className="investment-item">
                <div className="heading-3">Typical Engagement</div>
                <p className="body-medium">3-6 months for focused transformations</p>
              </div>
              <div className="investment-item">
                <div className="heading-3">Investment Range</div>
                <p className="body-medium">Custom pricing based on scope and outcomes</p>
              </div>
              <div className="investment-item">
                <div className="heading-3">Client Commitment</div>
                <p className="body-medium">Active participation from leadership team</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="consulting-cta-section">
        <div className="section-content">
          <div className="consulting-cta-content">
            <h2 className="display-large">Ready to Transform Your Business?</h2>
            <p className="body-large">
              Book a free strategy call to discuss your challenges and explore how we can help.
            </p>
            <Link to="/contact">
              <Button className="btn-primary large-btn">
                <span>Book a Strategy Call</span>
                <ArrowRight size={24} />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Consulting;
